import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/global.scss'
import Vant from 'vant'
import 'vant/lib/index.css'
import VueMeta from 'vue-meta'
import {
  installWorldCupDebug,
  logWorldCupDebug,
  removeWorldCupDebugUi,
  shouldEnableWorldCupDebug
} from '@/utils/worldcupDebug'

const worldCupDebugEnabled = shouldEnableWorldCupDebug()

if (worldCupDebugEnabled) {
  import(/* webpackChunkName: "worldcup-vconsole" */ 'vconsole').then(({ default: VConsole }) => {
    new VConsole({ theme: 'dark' })
  })
} else {
  removeWorldCupDebugUi()
}

installWorldCupDebug()

Vue.use(Vant)
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(VueMeta)

Vue.config.errorHandler = (err, vm, info) => {
  logWorldCupDebug('vue error', { info, error: err })
  console.error(err)
}

let clientWidth = document.body.clientWidth || document.documentElement.clientWidth
router.beforeEach((to, from, next) => {
  logWorldCupDebug('router beforeEach', {
    from: from.fullPath,
    to: to.fullPath,
    clientWidth
  })
  document.title = to.path.indexOf('/worldcup2026') === 0 ? '2026世界杯' : (to.meta.title || '默往')
  if (to.path === '/' && clientWidth < 500) {
    next('/download')
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  if (!shouldEnableWorldCupDebug()) {
    removeWorldCupDebugUi()
  }
  logWorldCupDebug('router afterEach', {
    from: from.fullPath,
    to: to.fullPath,
    title: document.title
  })
})

logWorldCupDebug('vue mount start')

const app = new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')

logWorldCupDebug('vue mount done', {
  hasApp: !!document.getElementById('app'),
  appHtmlLength: document.getElementById('app') ? document.getElementById('app').innerHTML.length : 0,
  vueUid: app && app._uid
})
